import { BaseApi, PassVersionMode } from '../base-api';

export class ClientSsoApi extends BaseApi {
  protected readonly prefix = 'clients';
  protected readonly version = '2';
  protected readonly passVersionMode = PassVersionMode.Prefix;

  deleteConsent = (clientId: string, coverage = 'organization') => this.delete(`${clientId}/consent`, { coverage });
}
